export default "__VITE_ASSET__BKRJWym7__"